module.exports = __webpack_public_path__ + "static/media/workout-tracker.084775f8.png";